import axios from "axios";
import { Constants, CookieService, Utils } from "../../../shared";

export const SystemParametersService = {

    /**
     * Fetch system parameters from the API.
     * @param {Object} params - The query parameters.
     * @returns {Promise} The promise object representing the API call.
     */
    fetchSystemParameters: (params) => {
       return axios.get(Constants.SystemParametersUrl, {
            params,
            headers: {
                ansid: CookieService.getCookie("ANsid"),
                clientid: Utils.getRouteParam("clientid")
            }
        })
        .then((response) => {
            return response
        })
    },

    /**
     * Update system parameters in the API.
     * @param {Object} payload - The data to be updated.
     * @returns {Promise} The promise object representing the API call.
     */
    updateSystemParameters: (payload) => {
        return axios.put(Constants.SystemParametersUrl, 
            payload,
            {
                headers: {
                    ansid: CookieService.getCookie("ANsid"),
                    clientid: Utils.getRouteParam("clientid")
                }
            })
            .then((response) => {
                return response
            })
        }
}